import styled from 'styled-components'

const ErrorMessage = styled.p`
    margin: 5px 0 0;
    color:${props => props.color ? `${props.color}` : `#ffde00`};
    font-size: .9rem;
    text-align: center;`

export default ErrorMessage